import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Wei amounts flow through the app as BigInts, but JSON.stringify throws on
// them — which crashes React 19's dev-mode render logging the moment a
// BigInt prop changes. Serialize them as strings everywhere.
declare global {
  interface BigInt {
    toJSON(): string;
  }
}
if (typeof BigInt.prototype.toJSON !== "function") {
  Object.defineProperty(BigInt.prototype, "toJSON", {
    value: function toJSON(this: bigint) {
      return this.toString();
    },
    writable: true,
    configurable: true,
  });
}
import { WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { config } from "./lib/chain";
import App from "./App";
import "./styles.css";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </WagmiProvider>
  </StrictMode>
);
